<template>
  <span class="spinner togo-icon-stack togo-icon-spinner-stack" :class="spanClass">
    <icon class="togo-icon-stack-1x togo-icon-spinner" :style="{color}"></icon>
    <icon class="togo-icon-stack-1x togo-icon-spinner-segment" :style="{color}"></icon>
  </span>
</template>

<script>
import Icon from './icon';

const Spinner = {
  name: 'Spinner',

  props: {
    size: {
      type: String
    },
    color: {
      type: String
    }
  },

  components: {
    Icon
  },

  computed: {
    spanClass() {
      const classes = {};

      if (this.size) {
        classes[`togo-icon-${this.size}`] = true;
      }

      return classes;
    }
  }
};

export default Spinner;
</script>
